<template>
    <div class="">
        <!--<ul class="process-steps nav nav-tabs nav-justified text-left">
            <li class="nav-item" v-on:click="setCurrentStep(1)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 1 }" href="#step1" data-toggle="tab">1</a>
                <h5>Booking Details</h5>
            </li>
            <li class="nav-item" v-on:click="setCurrentStep(2)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 2 }" href="#step2" data-toggle="tab">2</a>
                <h5>Passenger Details</h5>
            </li>
            <li class="nav-item" v-on:click="setCurrentStep(3)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 3 }" href="#step3" data-toggle="tab">3</a>
                <h5>Review</h5>
            </li>
            <li class="nav-item" v-on:click="setCurrentStep(4)">
                <a class="nav-link" v-bind:class="{ active: currentStep === 4 }" href="#step4" data-toggle="tab">4</a>
                <h5>Confirmation</h5>
            </li>
        </ul>-->
        <!--<div class="row" v-show="currentStep === 1 && isPriceLoading">
            <div class="col text-center">
                <i class="fa fa-2x fa-spinner fa-spin"></i>
                <h3>One moment please...</h3>
            </div>
        </div>-->

        <div class="row clearfix bookingDetails" v-show="currentStep === 1">
            <div class="col-sm-12 col-md-6">
                <booking-form></booking-form>
            </div>
            <div class="col-sm-12 col-md-6">
                <google-map style="min-height: 300px;" v-show="mapModel.visible" :map-visibility="currentStep === 1"
                            :map-model="mapModel" :map-center="mapModel.mapCenter" id="bookingMap"></google-map>
            </div>
        </div>
        <div class="chbs-main clearfix">
            <div class="row">
                <div class="col-md-9 order-lastt" v-if="currentStep > 1 && currentStep < 5">
                    <div class="bookingSelectCar" v-if="currentStep === 2">
                        <h2 class="">Select your car:</h2>
                        <!--<hr />-->
                        <vehicles-vertical-list></vehicles-vertical-list>
                    </div>
                    <div class="bookingPassengerDetails" v-if="currentStep === 3">
                        <h2>Passenger details:</h2>
                        <!--<hr />-->
                        <passenger-details></passenger-details>
                    </div>
                    <div class="bookingConfirmBooking" v-if="currentStep === 4">
                        <h2 class="">Confirm booking:</h2>
                        <div class="text-center display-table" v-if="canConfirmByPhone">
                            <h3 class="confirm-by-phone-header" style="">
                                <span style="display:inline-block;">Confirm by phone at:</span>
                                <a class="confirm-by-phone-number" :href="contactPhoneNumberHref">{{contactPhoneNumber}}</a>
                            </h3>
                        </div>
                        <div class="text-center" v-if="canConfirmByPhone">
                            <h3 class="mb-0">OR</h3>
                        </div>
                        <div class="text-center display-table" v-if="canConfirmByCash" style="margin-top: 15px; margin-bottom: 15px;">
                            <button type="button" class="price-container book-button mt-20" v-on:click="confirmByCash()">
                                <span>
                                    <span v-show="isCreateBookingInProgress"><i class="fa fa-spinner fa-spin"></i></span>
                                    Pay Cash To Driver - {{selectedCar.totalPrice | round(2, true) }} {{selectedCar.currency}}
                                </span>
                            </button>
                        </div>
                        <div class="text-center" v-if="canConfirmByCash" style="margin-bottom: 10px;">
                            <h3 class="mb-0">OR</h3>
                        </div>
                        <div>
                            <span class="mr-20">We accept the following payment methods:</span>
                            <img src="../../../../content/images/components/visa.png" />
                            <img src="../../../../content/images/components/mastercard.png" />
                            <img src="../../../../content/images/components/american-express.png" />
                            <img src="../../../../content/images/components/paypal.png" />
                        </div>

                        <payment-form></payment-form>

                        <div class="row text-center">
                            <div class="col-xs-6 col-sm-4 text-center"><img src="../../../../content/images/mcafeeSecure.png" /></div>
                            <div class="col-xs-6 col-sm-4 text-center"><img src="../../../../content/images/paypalLogo.png" /></div>
                            <div class="col-xs-12 col-sm-4 text-center"><img src="../../../../content/images/verisign.png" /></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 order-firstt" v-if="currentStep > 1 && currentStep < 5">
                    <booking-summary></booking-summary>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="currentStep === 5">
                    <booking-confirmation></booking-confirmation>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HtmlPageService from "./services/htmlPageService"
    import BookingForm from "./bookingForm/bookingFormComponent.vue";
    import VehiclesVerticalList from "./bookingForm/vehiclesVerticalListComponent.vue";
    import BookingSummary from "./bookingForm/bookingSummaryComponent.vue";
    import PassengerDetails from "./bookingForm/passengeDetailsComponent.vue";
    import GoogleMap from "./components/vue-google-map/vue-google-map.vue";
    import PaymentForm from "./bookingForm/paymentFormComponent.vue";
    import BookingConfirmation from "./bookingForm/bookingConfirmationComponent.vue";
    import { BookingStore } from "./vuexStores/index.js";
    import { round } from "./utils/filters.js"
    import Vue from 'vue'

    export default {
        //store: BookingStore,
        name: "BookingApp",
        components: {
            BookingForm, GoogleMap, BookingSummary, VehiclesVerticalList, PassengerDetails, PaymentForm, BookingConfirmation
        },
        mounted: function () {
            //check if we have empty cars and loading prices is true
            //if so -> trigger prices loading
            //         var isPriceLoading = this.$store.state.bookingInfo.general.isPriceLoading;
            var shouldLoadPrices = this.$store.state.bookingInfo.general.loadPricesFromServer;
            if (shouldLoadPrices) {
                this.$store.commit("setBookingPricesAreLoading", false);
                this.$store.dispatch('getBookingPrice');
            }
        },
        watch: {
            currentStep: function (oldValue, newValue) {
                if (newValue == 2) {
                    HtmlPageService.scrollElement('.bookingSelectCar', 20)
                } else if (newValue == 3) {
                    HtmlPageService.scrollElement('.bookingPassengerDetails', 20)
                } else if (newValue == 4) {
                    HtmlPageService.scrollElement('.bookingConfirmBooking', 20)
                }
            }
        },
        methods: {
            setCurrentStep: function (stepId) {
                this.$store.commit('setCurrentStep', stepId);
            },
            confirmByCash: function () {
                this.$store.commit('setBookingPaymentMethod', 'Cash');
                this.$store.commit('setIsCreateBookingInProgress', true);
                this.$store.dispatch('createBooking');
            }
        },
        computed: {
            contactPhoneNumber: function () {
                return this.$store.state.configuration.contactPhone;
            },
            selectedCar: {
                get: function () {
                    var car = this.$store.state.bookingInfo.selectedCar;
                    if (!car) return {};
                    return car;
                }
            },
            canConfirmByCash: function () {
                return this.$store.state.configuration.canConfirmByCash;
            },
            canConfirmByPhone: function () {
                return this.$store.state.configuration.canConfirmByPhone;
            },
            isCreateBookingInProgress: function () { return this.$store.state.uiState.isCreateBookingInProgress; },
            contactPhoneNumberHref: function () {
                return 'tel: +' + this.contactPhoneNumber;
            },
            isPriceLoading: function () { return this.$store.state.bookingInfo.general.isPriceLoading; },
            currentStep: function () {
                return this.$store.state.bookingInfo.currentStep;
            },
            distanceInMiles: function () {
                return this.$store.state.bookingInfo.general.distanceInMiles;
            },
            timeInMinutes: function () {
                return this.$store.state.bookingInfo.general.timeInMinutes;
            },
            isBookingConfirmed: function () {
                return this.$store.state.bookingInfo.payment.done;
            },
            mapModel: function () {
                console.log('map changed');
                var mm = this.$store.state.bookingInfo.mapInfo;
                if (mm.mapCenter == null) console.log("null center");
                return mm;
            }
        }
    }
</script>

<style>
    .cbs-car-select-title {
        margin-top: 10px;
        font-size: 18px;
        margin-bottom: 5px;
    }

    #header.transparent + section.page-header.page-header-xs {
        padding: 75px 0;
        padding-bottom: 20px;
    }

    .confirm-by-phone-header {
        font-size: 17px;
        margin-top: 0px;
        margin-bottom: 10px;
        line-height: 50px;
    }

    .confirm-by-phone-number {
        color: #24b47e;
        font-size: 24px;
        line-height: 50px;
        vertical-align: middle;
        padding-left: 10px;
    }

    .price-container.book-button {
        display: block;
        height: 40px;
        margin: 40px 15px 0;
        background-color: #24b47e;
        border-radius: 4px;
        color: #fff;
        text-transform: uppercase;
        font-weight: 600;
        cursor: pointer;
        width: 300px;
        margin: auto;
        outline: none;
        border-style: none;
    }
</style>